import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { ModalCard } from '@datapad/common-controls';
import { Add } from '@mui/icons-material';
import { AppBar, Box, FormControl, IconButton, InputLabel, MenuItem, Select, Tooltip, } from '@mui/material';
import React from 'react';
import { CampaignCreationForm } from './CampaignCreationForm.js';
var ModalStatus;
(function (ModalStatus) {
    ModalStatus[ModalStatus["None"] = 0] = "None";
    ModalStatus[ModalStatus["Creating"] = 1] = "Creating";
})(ModalStatus || (ModalStatus = {}));
export function Toolbar(props) {
    const { campaigns, selection: selectedCampaign, changeSelection: changeCampaignSelection, addCampaign, } = props;
    const [modalStatus, setModalStatus] = React.useState(ModalStatus.None);
    const maybeModal = (_jsx(EditingModal, { modalStatus: modalStatus, onAddNewCampaign: (campaign) => {
            addCampaign(campaign);
            setModalStatus(ModalStatus.None);
        }, onCancel: () => setModalStatus(ModalStatus.None) }));
    return (_jsxs(_Fragment, { children: [maybeModal, _jsxs(AppBar, { id: "profile-toolbar-div", position: "static", color: "default", sx: {
                    width: '100%',
                    display: 'flex',
                    flexDirection: 'row',
                    justifyContent: 'space-between',
                    pt: '7px',
                    pb: '2px',
                }, children: [_jsx(Box, { id: "profile-toolbar-filters", sx: { display: 'flex', flexDirection: 'row' }, children: _jsx(CampaignSelectionDropDown, { campaigns: campaigns, selection: selectedCampaign, changeSelection: changeCampaignSelection }) }), _jsx(Box, { id: "profile-toolbar-buttons", sx: { display: 'flex', flexDirection: 'row' }, children: _jsx(Tooltip, { title: "Add new campaign", children: _jsx(IconButton, { onClick: () => {
                                    setModalStatus(ModalStatus.Creating);
                                }, children: _jsx(Add, {}) }) }) })] })] }));
}
function CampaignSelectionDropDown(props) {
    const { campaigns, selection: selectedCampaign, changeSelection: changeCampaignSelection, } = props;
    if (campaigns.length === 0) {
        return _jsx(_Fragment, {});
    }
    const campaignSelectionOptions = campaigns.map((campaign) => (_jsx(MenuItem, { value: campaign.id, children: campaign.name }, `campaign-selection-option-${campaign.id}`)));
    return (_jsx(Box, { sx: {
            height: '100%',
            minWidth: 170,
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-around',
            pl: '5px',
            pr: '5px',
            textAlign: 'left',
        }, children: _jsxs(FormControl, { variant: "outlined", size: "small", children: [_jsx(InputLabel, { id: "campaign-selection-label", children: "Campaign Selection" }), _jsx(Select, { id: "campaign-selection-select", labelId: "campaign-selection-label", label: "Campaign Selection", value: selectedCampaign?.id, onChange: (event) => changeCampaignSelection(campaigns.find((c) => c.id === event.target.value)), variant: "outlined", children: campaignSelectionOptions })] }) }));
}
function EditingModal(props) {
    let renderedDialogue;
    switch (props.modalStatus) {
        case ModalStatus.None:
            renderedDialogue = undefined;
            break;
        case ModalStatus.Creating:
            renderedDialogue = (_jsx(CampaignCreationForm, { submit: props.onAddNewCampaign, cancel: props.onCancel }));
            break;
        default:
            throw new Error(`Unrecognized ModalStatus value: "${props.modalStatus}".`);
    }
    if (renderedDialogue === undefined) {
        return _jsx(_Fragment, {});
    }
    else {
        return (_jsx(ModalCard, { open: true, onClose: props.onCancel, children: renderedDialogue }));
    }
}
//# sourceMappingURL=Toolbar.js.map